import { createFocusOutlineStyle } from '@fluentui/react-tabster';
import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses, shorthands } from '@griffel/react';
export const switchClassNames = {
  root: 'fui-Switch',
  indicator: 'fui-Switch__indicator',
  input: 'fui-Switch__input',
  label: 'fui-Switch__label'
};
/**
 * @deprecated Use `switchClassNames.root` instead.
 */

export const switchClassName = switchClassNames.root; // Thumb and track sizes used by the component.

const spaceBetweenThumbAndTrack = 2;
const trackHeight = 20;
const trackWidth = 40;
const thumbSize = trackHeight - spaceBetweenThumbAndTrack;

const useRootStyles = /*#__PURE__*/__styles({
  "base": {
    "Bt984gj": "f6jr5hl",
    "B7ck84d": "f1ewtqcl",
    "mc9l5x": "ftuwxu6",
    "qhf8xq": "f10pi13n",
    "Brovlpu": "ftqa4ok",
    "B486eqv": "f2hkw1w",
    "n9p9qa": "f1fu8s9w",
    "B0otyzi": ["f8rbx7c", "f1jcuzx9"],
    "r10ruj": "f1c1apvh",
    "Bk2vswc": ["f1jcuzx9", "f8rbx7c"],
    "gjlbkn": "fyrlc8h",
    "B1kt0iq": "f28z38y",
    "Boi8ppg": "f1edqc4x",
    "Btfhvw2": "f19bnj08",
    "B55xfkk": "f17wg1r9",
    "i1dkbe": ["fgiioun", "fnx45sh"],
    "Bozs2tv": "f1ljqnps",
    "snkem8": ["fnx45sh", "fgiioun"],
    "Bjilewg": "fsacsau",
    "wht04d": ["flcxmxr", "f138axrn"],
    "vikdft": "f1f4bc3q",
    "Bwdhxlo": ["f138axrn", "flcxmxr"],
    "B167d6d": ["f5m7f7q", "f175edhc"],
    "Bpdw69r": ["f175edhc", "f5m7f7q"],
    "Bsdv7io": ["fhfahiz", "fnreirl"],
    "Bd353ur": ["fnreirl", "fhfahiz"],
    "Bcnuwmc": "fn9i64i",
    "dyfsa2": ["f1pylbqb", "f3dy9ja"],
    "Bdcx1rh": "f1v06qdr",
    "Bbd0xgj": ["f3dy9ja", "f1pylbqb"],
    "Bbretkc": "fm1yk70",
    "rnyfg7": "f1itvegt",
    "Bg18gms": ["f17e4q3j", "foxjjqz"],
    "Bym00rn": ["foxjjqz", "f17e4q3j"]
  },
  "vertical": {
    "Beiy3e4": "f1vx9l62"
  }
}, {
  "d": [".f6jr5hl{-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;}", ".f1ewtqcl{box-sizing:border-box;}", ".ftuwxu6{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;}", ".f10pi13n{position:relative;}", ".f1fu8s9w[data-fui-focus-visible]:focus-within{border-top-color:transparent;}", ".f8rbx7c[data-fui-focus-visible]:focus-within{border-right-color:transparent;}", ".f1jcuzx9[data-fui-focus-visible]:focus-within{border-left-color:transparent;}", ".f1c1apvh[data-fui-focus-visible]:focus-within{border-bottom-color:transparent;}", ".fyrlc8h[data-fui-focus-visible]:focus-within::after{content:\"\";}", ".f28z38y[data-fui-focus-visible]:focus-within::after{position:absolute;}", ".f1edqc4x[data-fui-focus-visible]:focus-within::after{pointer-events:none;}", ".f19bnj08[data-fui-focus-visible]:focus-within::after{z-index:1;}", ".f17wg1r9[data-fui-focus-visible]:focus-within::after{border-top-style:solid;}", ".fgiioun[data-fui-focus-visible]:focus-within::after{border-right-style:solid;}", ".fnx45sh[data-fui-focus-visible]:focus-within::after{border-left-style:solid;}", ".f1ljqnps[data-fui-focus-visible]:focus-within::after{border-bottom-style:solid;}", ".fsacsau[data-fui-focus-visible]:focus-within::after{border-top-width:2px;}", ".flcxmxr[data-fui-focus-visible]:focus-within::after{border-right-width:2px;}", ".f138axrn[data-fui-focus-visible]:focus-within::after{border-left-width:2px;}", ".f1f4bc3q[data-fui-focus-visible]:focus-within::after{border-bottom-width:2px;}", ".f5m7f7q[data-fui-focus-visible]:focus-within::after{border-bottom-right-radius:var(--borderRadiusMedium);}", ".f175edhc[data-fui-focus-visible]:focus-within::after{border-bottom-left-radius:var(--borderRadiusMedium);}", ".fhfahiz[data-fui-focus-visible]:focus-within::after{border-top-right-radius:var(--borderRadiusMedium);}", ".fnreirl[data-fui-focus-visible]:focus-within::after{border-top-left-radius:var(--borderRadiusMedium);}", ".fn9i64i[data-fui-focus-visible]:focus-within::after{border-top-color:var(--colorStrokeFocus2);}", ".f1pylbqb[data-fui-focus-visible]:focus-within::after{border-right-color:var(--colorStrokeFocus2);}", ".f3dy9ja[data-fui-focus-visible]:focus-within::after{border-left-color:var(--colorStrokeFocus2);}", ".f1v06qdr[data-fui-focus-visible]:focus-within::after{border-bottom-color:var(--colorStrokeFocus2);}", ".fm1yk70[data-fui-focus-visible]:focus-within::after{top:-2px;}", ".f1itvegt[data-fui-focus-visible]:focus-within::after{bottom:-2px;}", ".f17e4q3j[data-fui-focus-visible]:focus-within::after{left:-2px;}", ".foxjjqz[data-fui-focus-visible]:focus-within::after{right:-2px;}", ".f1vx9l62{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}"],
  "f": [".ftqa4ok:focus{outline-style:none;}"],
  "i": [".f2hkw1w:focus-visible{outline-style:none;}"]
});

const useIndicatorStyles = /*#__PURE__*/__styles({
  "base": {
    "Bbmb7ep": ["f8fbkgy", "f1nfllo7"],
    "Beyfa6y": ["f1nfllo7", "f8fbkgy"],
    "B7oj6ja": ["f1djnp8u", "f1s8kh49"],
    "Btl43ni": ["f1s8kh49", "f1djnp8u"],
    "icvyot": "fzkkow9",
    "vrafjx": ["fcdblym", "fjik90z"],
    "oivjwe": "fg706s2",
    "wvpqe5": ["fjik90z", "fcdblym"],
    "B4j52fo": "f5ogflp",
    "Bekrc4i": ["f1hqa2wf", "finvdd3"],
    "Bn0qgzm": "f1f09k3d",
    "ibv6hh": ["finvdd3", "f1hqa2wf"],
    "Bg96gwp": "fez10in",
    "B7ck84d": "f1ewtqcl",
    "Bkfmm31": "f1w9h62z",
    "Bnnss6s": "fi64zpg",
    "Be2twd7": "fg38ndl",
    "Bqenvij": "fjamq6b",
    "B6of3ja": "frnwi6n",
    "t21cq0": ["f1vcna3q", "foyynoy"],
    "jrapky": "fqcjy3b",
    "Frg6f3": ["foyynoy", "f1vcna3q"],
    "Bkecrkj": "f1aehjj5",
    "B3o57yi": "f1vze9yt",
    "Bkqvd7p": "f17wnm97",
    "Bmy1vo4": "fo99fu7",
    "a9b677": "feqmc2u",
    "Hwfdqs": "f1onx1g3",
    "Hkqiji": "f1h74hm9",
    "Bgrs90m": "f1592id",
    "B0zx559": "f1uwej41",
    "c0im90": "fpz7fqq"
  },
  "labelAbove": {
    "B6of3ja": "f1hu3pq6"
  }
}, {
  "d": [".f8fbkgy{border-bottom-right-radius:var(--borderRadiusCircular);}", ".f1nfllo7{border-bottom-left-radius:var(--borderRadiusCircular);}", ".f1djnp8u{border-top-right-radius:var(--borderRadiusCircular);}", ".f1s8kh49{border-top-left-radius:var(--borderRadiusCircular);}", ".fzkkow9{border-top-style:solid;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".fg706s2{border-bottom-style:solid;}", ".f5ogflp{border-top-width:1px;}", ".f1hqa2wf{border-right-width:1px;}", ".finvdd3{border-left-width:1px;}", ".f1f09k3d{border-bottom-width:1px;}", ".fez10in{line-height:0;}", ".f1ewtqcl{box-sizing:border-box;}", ".f1w9h62z{fill:currentColor;}", ".fi64zpg{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;}", ".fg38ndl{font-size:18px;}", ".fjamq6b{height:20px;}", ".frnwi6n{margin-top:var(--spacingVerticalS);}", ".f1vcna3q{margin-right:var(--spacingHorizontalS);}", ".foyynoy{margin-left:var(--spacingHorizontalS);}", ".fqcjy3b{margin-bottom:var(--spacingVerticalS);}", ".f1aehjj5{pointer-events:none;}", ".f1vze9yt{transition-duration:var(--durationNormal);}", ".f17wnm97{transition-timing-function:var(--curveEasyEase);}", ".fo99fu7{transition-property:background,border,color;}", ".feqmc2u{width:40px;}", ".f1h74hm9>*{transition-duration:var(--durationNormal);}", ".f1592id>*{transition-timing-function:var(--curveEasyEase);}", ".f1uwej41>*{transition-property:transform;}", ".f1hu3pq6{margin-top:0;}"],
  "m": [["@media screen and (prefers-reduced-motion: reduce){.f1onx1g3{transition-duration:0.01ms;}}", {
    "m": "screen and (prefers-reduced-motion: reduce)"
  }], ["@media screen and (prefers-reduced-motion: reduce){.fpz7fqq>*{transition-duration:0.01ms;}}", {
    "m": "screen and (prefers-reduced-motion: reduce)"
  }]]
});

const useInputStyles = /*#__PURE__*/__styles({
  "base": {
    "B7ck84d": "f1ewtqcl",
    "Bceei9c": "f1k6fduh",
    "Bqenvij": "f1l02sjl",
    "B6of3ja": "f1hu3pq6",
    "t21cq0": ["f11qmguv", "f1tyq0we"],
    "jrapky": "f19f4twv",
    "Frg6f3": ["f1tyq0we", "f11qmguv"],
    "abs64n": "fk73vx1",
    "qhf8xq": "f1euv43f",
    "a9b677": "f1ry1bn9",
    "fv8x6k": ["f3l1kk6", "f1kez0x4"],
    "ezr58z": "fvxnmui",
    "Blezdol": "f1cxq9o1",
    "k28iui": "f1q9yyk5",
    "B8f96ig": "f1ks1zsm",
    "po7uxr": "fiqfi0i",
    "inq7wv": "f9aagkg",
    "Cdugon": ["fgv8l18", "f1p3jmxb"],
    "ptsei1": "f11yi64e",
    "bl04ud": ["f1p3jmxb", "fgv8l18"],
    "Bu7dm46": "fthrly9",
    "Gwwlnz": "fhdp2ht",
    "wb1her": "f1rzj6jj",
    "Bmieemq": ["f1jywl1l", "f13d626x"],
    "Bdgjgzg": "f1ivtmze",
    "B05cvx7": ["f13d626x", "f1jywl1l"],
    "Bx4eqiv": "f1uvnr57",
    "xhnoxe": "frhcydi",
    "Hnmc4c": ["f1pvt3n7", "f14i0clv"],
    "By8gkvz": "fq9gcw4",
    "lekrm4": ["f14i0clv", "f1pvt3n7"],
    "Bei91sp": "f1se0d6r",
    "Bksztz9": "f8l9son",
    "h3gz1v": "f1c4gun2",
    "Cw6427": ["flhgtcm", "fx1zdd8"],
    "Bpbd9g9": "fayrp2e",
    "ssulyh": ["fx1zdd8", "flhgtcm"],
    "vq7rp1": "f1p715pa",
    "ynrfiu": "firogjh",
    "Bf5tpyt": ["f1crd6p1", "for8100"],
    "Brhic7g": "f1v5j4zb",
    "Cqvc5u": ["for8100", "f1crd6p1"],
    "B4e80u0": "f116zuoq",
    "Bwj41i9": "fxvotg6",
    "B2iiaa1": ["fk9ur30", "f3u5smv"],
    "Bejmxmv": "fdtj07x",
    "rqauf5": ["f3u5smv", "fk9ur30"],
    "wo5z87": "fv5mb1o",
    "B50joxe": ["f1i2l8ou", "fxj1kmv"],
    "Bmuizf1": "fku528b",
    "f4urji": ["fxj1kmv", "f1i2l8ou"],
    "Bxiq1ly": "fabcpc0",
    "vbmdq8": "f17xwy6w",
    "u4vbwo": ["fipwscc", "fab39iv"],
    "Bfjga03": "f1th5z1l",
    "F0s3py": ["fab39iv", "fipwscc"]
  },
  "highContrast": {
    "Bskmvfo": "f19h63kc",
    "zhypoe": "ffutfdj",
    "Bb6xxwe": ["f72m8yo", "f1ud47z9"],
    "o89t22": "f15xfkur",
    "B7qxyha": ["f1ud47z9", "f72m8yo"],
    "Bhmcd6p": "f1jaqqzs"
  },
  "before": {
    "j35jbq": ["f1e31b4d", "f1vgc2s3"],
    "Bhzewxz": "f15twtuk"
  },
  "after": {
    "oyh7mz": ["f1vgc2s3", "f1e31b4d"],
    "Bhzewxz": "f15twtuk"
  },
  "above": {
    "B5kzvoi": "f1yab3r1",
    "Bqenvij": "f1aar7gd",
    "a9b677": "fly5x3f"
  }
}, {
  "d": [".f1ewtqcl{box-sizing:border-box;}", ".f1k6fduh{cursor:pointer;}", ".f1l02sjl{height:100%;}", ".f1hu3pq6{margin-top:0;}", ".f11qmguv{margin-right:0;}", ".f1tyq0we{margin-left:0;}", ".f19f4twv{margin-bottom:0;}", ".fk73vx1{opacity:0;}", ".f1euv43f{position:absolute;}", ".f1ry1bn9{width:calc(40px + 2 * var(--spacingHorizontalS));}", ".f3l1kk6:checked~.fui-Switch__indicator>*{-webkit-transform:translateX(20px);-moz-transform:translateX(20px);-ms-transform:translateX(20px);transform:translateX(20px);}", ".f1kez0x4:checked~.fui-Switch__indicator>*{-webkit-transform:translateX(-20px);-moz-transform:translateX(-20px);-ms-transform:translateX(-20px);transform:translateX(-20px);}", ".fvxnmui:disabled{cursor:default;}", ".f1cxq9o1:disabled~.fui-Switch__indicator{color:var(--colorNeutralForegroundDisabled);}", ".f1q9yyk5:disabled~.fui-Switch__label{cursor:default;}", ".f1ks1zsm:disabled~.fui-Switch__label{color:var(--colorNeutralForegroundDisabled);}", ".fiqfi0i:enabled:not(:checked)~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessible);}", ".f9aagkg:enabled:not(:checked)~.fui-Switch__indicator{border-top-color:var(--colorNeutralStrokeAccessible);}", ".fgv8l18:enabled:not(:checked)~.fui-Switch__indicator{border-right-color:var(--colorNeutralStrokeAccessible);}", ".f1p3jmxb:enabled:not(:checked)~.fui-Switch__indicator{border-left-color:var(--colorNeutralStrokeAccessible);}", ".f11yi64e:enabled:not(:checked)~.fui-Switch__indicator{border-bottom-color:var(--colorNeutralStrokeAccessible);}", ".fthrly9:enabled:not(:checked)~.fui-Switch__label{color:var(--colorNeutralForeground1);}", ".fhdp2ht:enabled:not(:checked):hover~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessibleHover);}", ".f1rzj6jj:enabled:not(:checked):hover~.fui-Switch__indicator{border-top-color:var(--colorNeutralStrokeAccessibleHover);}", ".f1jywl1l:enabled:not(:checked):hover~.fui-Switch__indicator{border-right-color:var(--colorNeutralStrokeAccessibleHover);}", ".f13d626x:enabled:not(:checked):hover~.fui-Switch__indicator{border-left-color:var(--colorNeutralStrokeAccessibleHover);}", ".f1ivtmze:enabled:not(:checked):hover~.fui-Switch__indicator{border-bottom-color:var(--colorNeutralStrokeAccessibleHover);}", ".f1uvnr57:enabled:not(:checked):hover:active~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessiblePressed);}", ".frhcydi:enabled:not(:checked):hover:active~.fui-Switch__indicator{border-top-color:var(--colorNeutralStrokeAccessiblePressed);}", ".f1pvt3n7:enabled:not(:checked):hover:active~.fui-Switch__indicator{border-right-color:var(--colorNeutralStrokeAccessiblePressed);}", ".f14i0clv:enabled:not(:checked):hover:active~.fui-Switch__indicator{border-left-color:var(--colorNeutralStrokeAccessiblePressed);}", ".fq9gcw4:enabled:not(:checked):hover:active~.fui-Switch__indicator{border-bottom-color:var(--colorNeutralStrokeAccessiblePressed);}", ".f1se0d6r:enabled:checked~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackground);}", ".f8l9son:enabled:checked~.fui-Switch__indicator{color:var(--colorNeutralForegroundInverted);}", ".f1c4gun2:enabled:checked~.fui-Switch__indicator{border-top-color:var(--colorTransparentStroke);}", ".flhgtcm:enabled:checked~.fui-Switch__indicator{border-right-color:var(--colorTransparentStroke);}", ".fx1zdd8:enabled:checked~.fui-Switch__indicator{border-left-color:var(--colorTransparentStroke);}", ".fayrp2e:enabled:checked~.fui-Switch__indicator{border-bottom-color:var(--colorTransparentStroke);}", ".f1p715pa:enabled:checked:hover~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackgroundHover);}", ".firogjh:enabled:checked:hover~.fui-Switch__indicator{border-top-color:var(--colorTransparentStrokeInteractive);}", ".f1crd6p1:enabled:checked:hover~.fui-Switch__indicator{border-right-color:var(--colorTransparentStrokeInteractive);}", ".for8100:enabled:checked:hover~.fui-Switch__indicator{border-left-color:var(--colorTransparentStrokeInteractive);}", ".f1v5j4zb:enabled:checked:hover~.fui-Switch__indicator{border-bottom-color:var(--colorTransparentStrokeInteractive);}", ".f116zuoq:enabled:checked:hover:active~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackgroundPressed);}", ".fxvotg6:enabled:checked:hover:active~.fui-Switch__indicator{border-top-color:var(--colorTransparentStrokeInteractive);}", ".fk9ur30:enabled:checked:hover:active~.fui-Switch__indicator{border-right-color:var(--colorTransparentStrokeInteractive);}", ".f3u5smv:enabled:checked:hover:active~.fui-Switch__indicator{border-left-color:var(--colorTransparentStrokeInteractive);}", ".fdtj07x:enabled:checked:hover:active~.fui-Switch__indicator{border-bottom-color:var(--colorTransparentStrokeInteractive);}", ".fv5mb1o:disabled:not(:checked)~.fui-Switch__indicator{border-top-color:var(--colorNeutralStrokeDisabled);}", ".f1i2l8ou:disabled:not(:checked)~.fui-Switch__indicator{border-right-color:var(--colorNeutralStrokeDisabled);}", ".fxj1kmv:disabled:not(:checked)~.fui-Switch__indicator{border-left-color:var(--colorNeutralStrokeDisabled);}", ".fku528b:disabled:not(:checked)~.fui-Switch__indicator{border-bottom-color:var(--colorNeutralStrokeDisabled);}", ".fabcpc0:disabled:checked~.fui-Switch__indicator{background-color:var(--colorNeutralBackgroundDisabled);}", ".f17xwy6w:disabled:checked~.fui-Switch__indicator{border-top-color:var(--colorTransparentStrokeDisabled);}", ".fipwscc:disabled:checked~.fui-Switch__indicator{border-right-color:var(--colorTransparentStrokeDisabled);}", ".fab39iv:disabled:checked~.fui-Switch__indicator{border-left-color:var(--colorTransparentStrokeDisabled);}", ".f1th5z1l:disabled:checked~.fui-Switch__indicator{border-bottom-color:var(--colorTransparentStrokeDisabled);}", ".f1e31b4d{right:0;}", ".f1vgc2s3{left:0;}", ".f15twtuk{top:0;}", ".f1yab3r1{bottom:0;}", ".f1aar7gd{height:calc(20px + var(--spacingVerticalS));}", ".fly5x3f{width:100%;}"],
  "m": [["@media (forced-colors: active){.f19h63kc:disabled~.fui-Switch__indicator{color:GrayText;}}", {
    "m": "(forced-colors: active)"
  }], ["@media (forced-colors: active){.ffutfdj:disabled~.fui-Switch__indicator{border-top-color:GrayText;}}", {
    "m": "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f72m8yo:disabled~.fui-Switch__indicator{border-right-color:GrayText;}.f1ud47z9:disabled~.fui-Switch__indicator{border-left-color:GrayText;}}", {
    "m": "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f15xfkur:disabled~.fui-Switch__indicator{border-bottom-color:GrayText;}}", {
    "m": "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1ud47z9:disabled~.fui-Switch__indicator{border-left-color:GrayText;}.f72m8yo:disabled~.fui-Switch__indicator{border-right-color:GrayText;}}", {
    "m": "(forced-colors: active)"
  }], ["@media (forced-colors: active){.f1jaqqzs:disabled~.fui-Switch__label{color:GrayText;}}", {
    "m": "(forced-colors: active)"
  }]]
});

const useLabelStyles = /*#__PURE__*/__styles({
  "base": {
    "Bceei9c": "f1k6fduh",
    "jrapky": "f49ad5g",
    "B6of3ja": "f1xlvstr",
    "z8tnut": "f1kwiid1",
    "z189sj": ["f1vdfbxk", "f1f5gg8d"],
    "Byoj8tv": "f5b47ha",
    "uwmqm3": ["f1f5gg8d", "f1vdfbxk"]
  },
  "above": {
    "z8tnut": "f1ywm7hm",
    "Byoj8tv": "f14wxoun",
    "a9b677": "fly5x3f"
  },
  "after": {
    "uwmqm3": ["fruq291", "f7x41pl"]
  },
  "before": {
    "z189sj": ["f7x41pl", "fruq291"]
  }
}, {
  "d": [".f1k6fduh{cursor:pointer;}", ".f49ad5g{margin-bottom:calc((20px - var(--lineHeightBase300)) / 2);}", ".f1xlvstr{margin-top:calc((20px - var(--lineHeightBase300)) / 2);}", ".f1kwiid1{padding-top:var(--spacingVerticalS);}", ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}", ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}", ".f5b47ha{padding-bottom:var(--spacingVerticalS);}", ".f1ywm7hm{padding-top:var(--spacingVerticalXS);}", ".f14wxoun{padding-bottom:var(--spacingVerticalXS);}", ".fly5x3f{width:100%;}", ".fruq291{padding-left:var(--spacingHorizontalXS);}", ".f7x41pl{padding-right:var(--spacingHorizontalXS);}"]
});
/**
 * Apply styling to the Switch slots based on the state
 */


export const useSwitchStyles_unstable = state => {
  const rootStyles = useRootStyles();
  const indicatorStyles = useIndicatorStyles();
  const inputStyles = useInputStyles();
  const labelStyles = useLabelStyles();
  const {
    label,
    labelPosition
  } = state;
  state.root.className = mergeClasses(switchClassNames.root, rootStyles.base, labelPosition === 'above' && rootStyles.vertical, state.root.className);
  state.indicator.className = mergeClasses(switchClassNames.indicator, indicatorStyles.base, label && labelPosition === 'above' && indicatorStyles.labelAbove, state.indicator.className);
  state.input.className = mergeClasses(switchClassNames.input, inputStyles.base, inputStyles.highContrast, label && inputStyles[labelPosition], state.input.className);

  if (state.label) {
    state.label.className = mergeClasses(switchClassNames.label, labelStyles.base, labelStyles[labelPosition], state.label.className);
  }

  return state;
};
//# sourceMappingURL=useSwitchStyles.js.map